import * as React from 'react';
import './DueDiligenceRequest.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Project from 'src/entities/Project';
import InvestmentFunnelHeaderComponent
  from 'src/modules/modals/investment-funnel/partials/InvestmentFunnelHeader.component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface DueDiligenceRequestComponentProps {
  project: Project;
  modalRef?: Modal;
  isChecked: boolean;
  handleClick: () => void;
  handleSubmit: () => void;
  errorMessage: {};
  success: boolean;
}

const DueDiligenceRequestComponent = (props: DueDiligenceRequestComponentProps) => {
  return (
    props.success ? (
        <div className="modal-content due-diligence-request-component">
          <div className="modal-body text-center">
            <div className="gap-20"/>
            <span className="corrected-circle"/>
            <div className="gap-20"/>
            <p>
              <strong>
                Ya hemos recibido tu solicitud
              </strong>
            </p>
            <p>
              Revisa el correo electrónico para firmar la carta de liberación
            </p>
          </div>
        </div>
      ) :
      (
        <div className="modal-content due-diligence-request-component">
          <InvestmentFunnelHeaderComponent
            logo={props.project.company.logo}
            modalRef={props.modalRef}
          />
          <div className="modal-body">
            <p>
              <strong>Apreciado inversor/a,</strong><br/><br/>
              En caso de que estés interesado, previamente tendrás que firmar el documento de confidencialidad y
              aceptación de
              condiciones de la misma.<br/><br/>
              Una vez lo tengamos disponible por parte de los abogados del despacho encargados de realizar este proceso,
              será
              enviado a aquellos que hayan mostrado interés y firmado el documento de confidencialidad y liberación.
              Dicho
              documento se os hará llegar por medio de la plataforma de firmas.
            </p>
            <div className="gap-10"/>
            <div className="checkbox">
              <input
                type="checkbox"
                checked={props.isChecked}
              />
              <label
                style={{fontSize: '14px'}}
                onClick={() => props.handleClick()}
              >
                Solicito la <strong>Carta de liberación</strong> de {props.project.company.name}
              </label>
            </div>
            <div className="text-right">
              <button
                className="btn"
                onClick={() => props.handleSubmit()}
              >
                Solicitar
              </button>
              <div className="gap-20"/>
              <ErrorMessagesComponent
                errorMessage={props.errorMessage}
              />
            </div>
          </div>
        </div>
      )
  );
};

export default DueDiligenceRequestComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/due-diligence-request/DueDiligenceRequest.component.tsx